<div class="ckeditor-container" #ckEditorContainer></div>